<script setup lang="ts">
defineProps<{
  icons: string[],
  title: string,
  open?: boolean,
}>();
</script>
<template>
  <div>
    <UiFaIcon :icon="icons" />
  </div>
  <div>
    {{ title }}
  </div>
  <UiFaIcon
    v-if="icons"
    :icon="['fal', open ? 'chevron-down' : 'chevron-right']"
    class="ml-2 -mr-1 h-5 w-5 "
  />
</template>
